"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchPickupPoints = void 0;
var _fetching = require("@ori/fetching");
var _queriesNet = require("../queries-net");
var _utils = require("../utils");
// istanbul ignore file -- api

const fetchPickupPoints = async ({
  headers,
  graphQlNetUrl,
  params
}) => {
  const detailData = await (0, _fetching.fetchGraphql)({
    query: _queriesNet.deliveryChannelsQuery,
    url: graphQlNetUrl,
    headers,
    variables: {
      ...params,
      latitude: params.searchTerm ? undefined : params.latitude,
      longitude: params.searchTerm ? undefined : params.longitude,
      radius: params.searchTerm ? undefined : params.radius
    }
  });
  const {
    totalRecords,
    collection
  } = detailData.shopping?.shoppingSession?.deliveryChannels ?? {};
  return {
    pickupPoints: (collection ?? []).filter(pickupPoint => pickupPoint != null).map(_utils.mapPickupPoint),
    totalRecords: totalRecords ?? 0
  };
};
exports.fetchPickupPoints = fetchPickupPoints;